import { Button } from 'beautiful-react-ui';
import '../../styles/CustomRender.scss';
import { RenderProps } from './RenderProps';
import { RenderHelper } from './RenderHelper';

export function CustomRender(props: RenderProps) {
    
    let inpDivs = props.inputs ? RenderHelper.makeInputDivs(props.inputs, props.data.inputNames) : [];
    let outDivs = props.outputs ? RenderHelper.makeOutputDivs(props.outputs, props.data.outputNames) : [];
 
    return (
        <div className={"node-wrapper"}>
            <div className={props.data.problematic ? "custom-node-problem" : "custom-node"} >
                <div className="deleteBtn">
                    <Button icon="times" size="small" onClick={() => RenderHelper.deleteNode(props.data.parentSchema, props.id)} />
                </div>
                <div className="ports">
                    <div className="inputs">
                        {inpDivs}
                    </div>
                    <div className="content">
                        {props.content}
                    </div>
                    <div className="outputs">
                        {outDivs}
                    </div>
                </div>
            </div>
        </div>
    )
}

